import '../bars';

describe('test icons-bars', () => {
  it('Expect custom element <icon-bars /> is defined', () => {
    const el = customElements.get('icon-bars');
    expect(el).toBeDefined();
  });
});
